import React from 'react';
import { ShortCarouselCard, LazyLoadAspectRatioCardImage, AspectRatioCardTitle, AspectRatioCardText } from '../Carousel/CarouselCard';

const CardMLPModule = ({ clickUrl, imageUri, title, subtitle, onClick }) => (
  <ShortCarouselCard clickUrl={clickUrl} onClick={onClick}>
    <LazyLoadAspectRatioCardImage data-slot={'figure'} imageUri={imageUri} />
    <AspectRatioCardTitle data-slot={'caption'} title={title} />
    <AspectRatioCardText data-slot={'content'} text={subtitle} />
  </ShortCarouselCard>
);

export default CardMLPModule;
